<template>
    <b-modal id="medicineSearch01" :title="title" size="md" @show="fn_search">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control" v-model="medHubNm" @keyup.enter="fn_search">
                    <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
                </li>
              <li v-show="filter">
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" checked>
                  <label for="radio1">전체</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio">
                  <label for="radio2">기준재고량 미달</label>
                </div>
              </li>
            </ul>
            <div class="modal_table">
                <table class="list">
                    <colgroup>
                        <col width="50">
                        <col width="50">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>약재코드</th>
                            <th>약재명</th>
                            <th>이명</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(td, index) in medicineList" :key="index" :class="td.standard_yn != 'Y'? 'red' : ''">
                        <td>
                            <div class="form_checkbox">
                                <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="checkBox" :value="index" @change="fn_check">
                                <label :for="'checkbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ index + 1 }}</span></td>
                        <td><span>{{ td.med_hrb_cd }}</span></td>
                        <td><span>{{ td.med_hrb_nm }}</span></td>
                        <td><span>{{ td.med_alias }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">        
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'

    export default {
        name: 'medicineSearch01',
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            searchName: String,
            searchData: String,
            oneBtn: Boolean,
            filter: Boolean,
        },
        data() {
            return {
                checkBox : [],
                medicineList : [],
                medHubNm : this.searchData
            }
        },
        methods : {
            fn_search(){

                let param = new Object();
                param.medHubNm = this.medHubNm;

                console.log("@@@@ param : %o",param);

                axios
                    .post("/api/medicine/searchModalMedicine01", param)
                    .then((res) => {
                        console.log("@@@@ dtl res : %o",res);
                        this.medicineList = res.data.medicineInfo;
                    })
                    .catch((err) => console.log(err));
                
            },
            fn_apply(){
                               
                if(this.checkBox.length == 0){
                    alert("체크된 약재가 없습니다.");
                }else if(this.checkBox.length > 1){
                    alert("한개 이상 선택할수 없습니다.");
                }else{                    
                    
                    let medObject = this.medicineList[this.checkBox[0]];
                    
                    //let medCode = this.medicineList[this.checkBox[0]].med_hrb_cd;
                    //let medName = this.medicineList[this.checkBox[0]].med_hrb_nm;
                    //let medHrbDtlSeq = this.medicineList[this.checkBox[0]].med_hrb_dtl_seq;
                    //let orgPlceNm = this.medicineList[this.checkBox[0]].org_plce_nm;


                    this.$emit('callback', medObject);

                    this.fn_init();
                    this.$bvModal.hide('medicineSearch01');
                }                                        
            },
            fn_init(){
                this.medicineList = [];
                this.checkBox = [];
                this.medHubNm = '';
            },
            fn_check(){
                if(this.checkBox.length > 1){
                    this.checkBox.splice(0,1);
                }
            }
        }
    }
</script>
